<template>
  <div class="m-radiocard" :class="shouldBeChecked ? 'm-radiocard--selected' : ''">
    <input class="m-radiocard__input" type="radio" :checked="shouldBeChecked" :value="value" @change="updateInput">
    <slot></slot>
    <label class="m-radiocard__label" v-html="this.label"></label>
    <div class="m-radiocard__popover">
      <slot name="popover"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RadioCard',
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    value: {
      type: String,
    },
    modelValue: {
      default: ''
    },
    label: {
      type: String,
      required: true
    }
  },
  computed: {
    shouldBeChecked () {
      return this.modelValue == this.value
    }
  },
  methods: {
    updateInput () {
      this.$emit('change', this.value, 'answered')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../scss/vars';
.m-radiocard {
  position: relative;
  width: 97px;
  height: 126px;
  border-radius: 6px;
  border: 2px solid transparent;
  background-color: $cWhite;
  -webkit-box-shadow: -1px 2px 10px 5px rgba(212,215,220,1);
  -moz-box-shadow: -1px 2px 10px 5px rgba(212,215,220,1);
  box-shadow: -1px 2px 10px 5px rgba(212,215,220,1);
  // margin: 10px;
  display: flex;
  flex-flow: column;
  justify-content: space-around;
  align-items: center;
  @media (max-width: $sm) {
    width: 80%;
    height: 70px;
    margin: 0 auto 20px;
  }
  &--selected {
    border: 2px solid $cTeal;
  }
  &__input {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    opacity: 0;
    cursor: pointer;
  }
  &__label {
    font-family: $fPrimary;
    font-size: 12px;
    line-height: 16px;
    font-weight: $fReg;
    text-align: center;
    display: block;
    width: 100%;
  }
  &__popover {
    position: absolute;
    top: -12px;
    right: -12px;
  }
}

</style>
